// icons/redundancy.svg

export const RedundancyIconV2 = (props) => (
  <svg
    className={props.className}
    width="25"
    height="34"
    viewBox="0 0 25 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5416 3.25C15.6583 3.25 18.0416 5.63333 18.0416 8.75C18.0416 11.8667 15.6583 14.25 12.5416 14.25C9.42496 14.25 7.04163 11.8667 7.04163 8.75C7.04163 5.63333 9.42496 3.25 12.5416 3.25ZM12.5416 0.5C7.95829 0.5 4.29163 4.16667 4.29163 8.75C4.29163 13.3333 7.95829 17 12.5416 17C17.125 17 20.7916 13.3333 20.7916 8.75C20.7916 4.16667 17.125 0.5 12.5416 0.5Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.12496 23.875C4.5089 23.875 2.91663 25.4362 2.91663 27.8167V33.5H0.166626V27.8167C0.166626 24.3304 2.60768 21.125 6.12496 21.125H18.9583C20.7561 21.125 22.3968 22.1317 23.4979 23.4531L21.3853 25.2136C20.6531 24.335 19.7272 23.875 18.9583 23.875H6.12496Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0693 31.7945L22.2027 26.6611L24.1472 28.6057L19.0139 33.739L17.0693 31.7945Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0139 26.6611L24.1472 31.7945L22.2027 33.739L17.0693 28.6057L19.0139 26.6611Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0139 26.6611L24.1472 31.7945L22.2027 33.739L17.0693 28.6057L19.0139 26.6611Z"
      fill="#34363E"
    />
  </svg>
);
